import Vue from 'vue';
import LocationPlugin from './LocationPlugin/index';

Vue.use(LocationPlugin, {
  baseUrl: process.env.WEB_HOST,
});
